import script from "./EditProfileMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfileMobile.vue?vue&type=script&setup=true&lang=js"

import "./EditProfileMobile.vue?vue&type=style&index=0&id=540a662a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540a662a"]])

export default __exports__